import { useEffect } from "react";
import SEO from "@/lib/seo-pages.json";

const SITE = SEO.name;
const ORIGIN = SEO.site;

export const SEO_PAGES = SEO.pages;

export function buildJsonLd(page, path = "/") {
  const strip = ({ "@context": _c, ...rest }) => rest;
  const graph = [{ ...strip(page.jsonLd), url: `${ORIGIN}${path}` }, ORG];
  if (path !== "/") {
    graph.push({ "@type": "BreadcrumbList", itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${ORIGIN}/` },
      { "@type": "ListItem", position: 2, name: page.h1, item: `${ORIGIN}${path}` }] });
  }
  if (page.faq) {
    graph.push({ "@type": "FAQPage", mainEntity: page.faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) });
  }
  return { "@context": "https://schema.org", "@graph": graph };
}

const ORG = { "@type": "Organization", "@id": `${ORIGIN}/#organization`, name: SITE, url: `${ORIGIN}/`, logo: `${ORIGIN}/brand/logo-square.jpg`,
  email: "Greg@DigitalNomadNicaragua.com", telephone: "+50586156364", founder: { "@type": "Person", name: "Greg Miceli" },
  areaServed: "Nicaragua", sameAs: ["https://gregmiceli.com"] };

export function pageSeo(path) {
  const page = SEO_PAGES[path];
  return { title: page.title, description: page.description, path, jsonLd: buildJsonLd(page, path), image: page.image };
}

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path = "/", jsonLd, noindex = false, image = "/og-image.jpg" }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : SITE;
    const url = `${ORIGIN}${path}`;
    document.title = full;
    setMeta("name", "description", description || "");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${ORIGIN}${image}`);
    setMeta("name", "twitter:image", `${ORIGIN}${image}`);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description || "");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) script.remove();
  }, [title, description, path, jsonLd, noindex, image]);
}
